var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "92e0f1723a9dc375f2198dab5ac9c546929f2f41"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["auto-companion@cege-media"] = {
  id: "92e0f1723a9dc375f2198dab5ac9c546929f2f41"
};